{partitionAndSort, getIdsAsList, get_from_list} = require('../../utils')
moment = require('moment')
_ = require('lodash')

module.exports = (
  $scope,
  $rootScope,
  $filter,
  $interval,
  $timeout
  $state,
  $stateParams,
  $http,
  $uibModal,
  $q,
  settings,
  Api,
  endpoints,
  managedUsers,
  processes,
  states,
  countries,
  countryAliases,
  polling,
  workflowTemplates,
  adverseTermsLists,
  User,
  cfpLoadingBar
) ->

  $scope.user = User
  $scope.searchNameValidationMessage = ""

  $scope.stepCounter = () ->
    $scope.projects = ((->
      project.complete = true
      project.stepsTotal = 0
      # 'not_applicable' and 'completed' are distinct statuses, but both are treated as 'finalized'.
      project.stepsFinalized = 0

      for workflow in project.workflows or []
        for step in $scope.workflowSteps[workflow.id] or []
          project.stepsTotal++
          if not step.complete and not step.not_applicable
            project.complete = false
          else
            project.stepsFinalized++
      project
    )() for project in $scope.projects or [])

  $scope.getCurrentPage = (offset, limit) ->
    if offset and limit
      return offset / limit + 1
    else
      return 1

  # =========================
  # -------- Actions --------
  # =========================

  $scope.archiveProject = (project) ->
    confirmation = confirm("Are you sure you want to delete this report?")
    if confirmation
      project.archived = !project.archived
      updateProject = new Api.Project
        id: project.id
        archived: project.archived
      updateProject.$update()

  $scope.assignProject = (scope, project, assignedOwnerId) ->
    if assignedOwnerId?
      $scope.$emit('$stateChangeStart', true)
      Api.AssignProject.save {project: project.id, owner: assignedOwnerId}, (data) ->
        scope.saving = true
        $scope.$emit('$stateChangeSuccess', true)
        $timeout ->
          scope.saving = false
        , 1500

  $scope.filterReportName = () ->
    $scope.loadPage(1)

  $scope.loadPage = (page) ->
    $scope.page = page or $scope.page
    limit = settings.REPORTS_PER_PAGE
    offset = ($scope.page - 1) * limit
    $scope.state = 'start'

    # if the search box is not valid, don't filter by name, and show a message
    searchText = $scope.searchText

    $scope.loadData
      offset: offset
      limit: limit
      archived: "false"
      name: searchText
      customer_id: searchText
      state: $scope.filters.state
      owner: $scope.filters.assignee
      country: $scope.filters.country

  $scope.getReportUrl = (project) ->
    workflowsInProject = (w.id for w in project.workflows) # list of workflow ids in this project
    filteredWorkflowStepsArray = _.filter $scope.workflowStepsArray, (workflowStep) -> workflowsInProject.indexOf(workflowStep.workflow) isnt -1
    sortedWorkflowStepsArray = _.sortBy filteredWorkflowStepsArray, (workflowStep) -> workflowsInProject.indexOf(workflowStep.workflow)
    # find the first step in this project that isn't complete
    incompleteStep = (r for r in sortedWorkflowStepsArray when r.complete isnt true and r.not_applicable isnt true)[0]
    if incompleteStep
      return $state.href('project.workflow.step', {projectId:project.id, workflowId:incompleteStep.workflow, workflowStepId:incompleteStep.id})
    else
      return $state.href('project.export', {projectId:project.id})

  $scope.clickReport = (project) ->
    workflowsInProject = (w.id for w in project.workflows) # list of workflow ids in this project
    filteredWorkflowStepsArray = _.filter $scope.workflowStepsArray, (workflowStep) -> workflowsInProject.indexOf(workflowStep.workflow) isnt -1
    sortedWorkflowStepsArray = _.sortBy filteredWorkflowStepsArray, (workflowStep) -> workflowsInProject.indexOf(workflowStep.workflow)
    # find the first step in this project that isn't complete
    incompleteStep = (r for r in sortedWorkflowStepsArray when r.complete isnt true)[0]
    if incompleteStep
      $state.go('project.workflow.step', {projectId:project.id, workflowId:incompleteStep.workflow, workflowStepId:incompleteStep.id})
    else
      $state.go('project.export', {projectId:project.id})


  $scope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams, options) ->
    $scope.startQuickReportRedirecting = true
  )

  # =========================
  # -------- Display --------
  # =========================

  $scope.showNoProjectMessage = () ->
    if ($scope.loading ? true)
      return false
    return $scope.projects.length == 0

  stepIterator = (project, stepOK) ->
    for workflow in project.workflows or []
      for step in $scope.workflowSteps[workflow.id] or []
        if not stepOK(step)
          return false
    return true

  $scope.projectStepsAutomaticallyComplete = (project) ->
    return stepIterator(project, (step) ->
      return step.complete and step.automatically_marked_complete
    )

  $scope.projectStepsComplete = (project) ->
    return stepIterator(project, (step) ->
      return step.complete
    )

  $scope._processWorkflowSteps = (workflowSteps) ->
    $scope.workflowStepsArray = workflowSteps
    $scope.workflowSteps = partitionAndSort(workflowSteps, 'workflow', 'id')
    $scope.stepCounter()

  $scope._processProjects = (projects) ->
    $scope.hasNextPage = Boolean(projects.next)
    $scope.projects = projects.results
    $scope.loading = false
    $scope.stepCounter()
    projectIds = (project.id for project in projects.results)
    if projectIds.length > 0
      (Api.WorkflowStep.query {'project': projectIds}).$promise.then $scope._processWorkflowSteps

  $scope.polling_params_integrety_check = undefined

  $scope._addOrdering = (params) ->
    # Add the ordering parameter if the user has one set in their userprofile
    if $scope.user.userprofile?.project_order
      params.ordering = $scope.user.userprofile.project_order
    return params

  projectPaginationSearch = (params) ->
    isNameValid = !params.name || params.name.length >= 3
    isCustomeridValid = params.customer_id?.length > 0

    return $q(
      (resolve, reject) ->
        if isCustomeridValid && isNameValid
          $q.all([
            Api.ProjectPagination.query(Object.assign({}, params, {name: undefined} )).$promise
            Api.ProjectPagination.query(Object.assign({}, params, {customer_id: undefined} )).$promise
          ])
          .then (results) -> resolve(mergePaginationResponses(results))
          .catch((error) -> reject(error))
        else if isNameValid
          Api.ProjectPagination.query(Object.assign({}, params, {customer_id: undefined} ))
            .$promise
            .then((result) -> resolve(result))
            .catch((error) -> reject(error))
        else if isCustomeridValid
          Api.ProjectPagination.query(Object.assign({}, params, {name: undefined} ))
            .$promise
            .then((result) -> resolve(result))
            .catch((error) -> reject(error))
        else
          Api.ProjectPagination.query(params)
            .$promise
            .then((result) -> resolve(result))
            .catch((error) -> reject(error))
    )

  $scope.reportPollingInterval = settings.REPORT_POLLING_INTERVAL
  $scope.executePoll = () ->
    params_integrity_check = angular.copy($scope.polling_params)

    return $q(
      (resolve, reject) ->
        projectPaginationSearch($scope.polling_params)
        .then (projects) ->
          if angular.equals(params_integrity_check, $scope.polling_params)
            $scope._processProjects(projects)
          resolve()
        .catch (error) -> reject(error)
    )

  $scope.hasPendingReports = () ->
    for project in $scope.projects
      if project.created == false
        return true
    return false

  $scope.isScopeDestroying = false
  $scope.pollReports = (query) ->
    if query
        $scope.polling_params = query
        # If the user is configured to use a project order we include it in the query to the project-pagination endpoint
        $scope.polling_params = $scope._addOrdering(query)
    $scope.executePoll().then () ->
      # Set the polling interval to the initial value if the request is successful.
      # We increase the polling interval when a request fails, so we want to reset it
      # if the requests start succeeding.
      $scope.reportPollingInterval = settings.REPORT_POLLING_INTERVAL
      if not $scope.isScopeDestroying and $scope.hasPendingReports()
        window.clearTimeout($scope.timeoutID)
        $scope.timeoutID = window.setTimeout($scope.pollReports, $scope.reportPollingInterval)
    .catch (error) ->
      # In the past we were increasing the polling interval when a request failed, up to
      # a maxPollingInterval (5 minutes).
      #
      # There were cases where a given project pagination request was taking a long time
      # to complete (for instance an expensive filter which matches a lot of reports),
      # and retrying the same requests was putting a lot of pressure in the database.
      #
      # For that reason, we decided to stop polling reports when a request fails.
      window.clearTimeout($scope.timeoutID)

  $scope.pollAndRedirectToQuickCreatedReports = (lastCreatedProjectId) ->
    executePoll = ->
      (Api.Project.get {id: lastCreatedProjectId}).$promise.then (project) ->
        if project.created
          (Api.WorkflowStep.query {'project': [project.id]}).$promise.then (workflowSteps) ->
            if $scope.shouldRedirectToNewReport and angular.equals(lastCreatedProjectId, $scope.lastCreatedProjectId)
              $scope._processWorkflowSteps(workflowSteps)
              $scope.lastCreatedProjectId = null
              $scope.clickReport(project)

    executePoll()
    $interval(executePoll, settings.QUICK_CREATED_REPORT_POLLING_INTERVAL)

  $scope.loadData = (params) ->
    $scope.loading = true
    window.clearTimeout($scope.timeoutID)

    pollReports = $scope.pollReports(params)
    $scope.$on '$destroy', ->
      $scope.isScopeDestroying = true
      window.clearTimeout($scope.timeoutID)

  $scope.hasFilter = (name) ->
    return $scope.filters[name]?

  $scope.groupByStateName = (states) ->
    _.chain(states).groupBy('name').map((value, key) ->
      {
        name: key
        states: _.map(value, 'id')
      }
    ).value()

  # =========================
  # --------- Scope ---------
  # =========================

  $scope.managedUsers = managedUsers
  $scope.countries = countries

  $scope.states = states
  $scope.statesByProcess = partitionAndSort(states, 'process', 'id')
  $scope.statesByName = $scope.groupByStateName(states)

  $scope.saving = false
  $scope.workflowSteps = {}

  $scope.userCanRunDeltaReport = User.hasPermission('workflow.can_run_delta_report', false)

  $scope.bulkUploadAllowed = User.hasPermission('workflow.add_bulkupload', false)
  $scope.createReportAllowed = User.hasPermission('workflow.add_project', false)
  $scope.deleteReportAllowed = User.hasPermission('workflow.change_project_archived', false)
  $scope.subjectNameAutoFilter = User.hasPermission('workflow.subject_name_auto_filter', false)
  $scope.doNotFilterOwnerByDefault = User.hasPermission('workflow.do_not_filter_owner_by_default', false)

  $stateParams.archived ?= "false"
  # If the user has the permission do_not_filter_owner_by_default then we do not populate the assignee filter
  # If they do not have this permission we filter the list of reports to ones assigned to them
  $stateParams.owner ?= if $scope.doNotFilterOwnerByDefault then null else $scope.user.id
  $scope.loadData($stateParams)

  # Basing this variable on `change_project` will have an unintended side effect
  # of blocking executive summary changes. Rather, the desired behaviour is to
  # prevent 'editing a project' which on the front-end only entails adding new
  # workflows only (editing the name of a project is not currently available in
  # the front-end).
  $scope.updateReportAllowed = User.hasPermission('workflow.add_workflow', false)

  # Allow the assignee to be changed if the user has the permission to do so,
  # and if the user has a list of users that they are managing.
  $scope.changeReportOwnerAllowed = User.hasPermission('workflow.change_project_owner', false) && managedUsers.length

  $scope.changeReportStatusAllowed = (report) ->
    User.projectPermissions(report).changeReportStatus

  $scope.currentPage = $scope.getCurrentPage($stateParams.offset, $stateParams.limit)
  $scope.searchText = $stateParams.name

  $scope.filters =
    assignee: $stateParams.owner
    country: $stateParams.country
    state: $stateParams.state

  ################################################################################
  ### Quick create report                                                      ###
  ################################################################################

  $scope.shouldRedirectToNewReport = false
  $scope.lastCreatedProjectId = null
  $scope.startQuickReportRedirecting = false
  $scope.processes = processes
  $scope.workflowTemplates = workflowTemplates
  $scope.adverseTermsLists = adverseTermsLists
  # named qc_countries to avoid conflicting with $scope.countries above
  $scope.qc_countries = ({
    id: c.id,
    name: c.name,
    iso_code: c.iso_code,
    aliases: countryAliases[c.name],
    subdivisions: c.subdivisions
  } for c in countries)

  for c in $scope.qc_countries
    if c.iso_code == "glo"
      c.name = $scope.user.unknown_country_name

  resetQuickCreateForm = () ->
    $scope.form = {
      simple_names: [{'name': ''}],
      entityType: null,
      template: undefined,
      country: undefined,
      adverseTermsId: undefined,
    }

  resetQuickCreateForm()

  $scope.itemsLimit = 1000
  $scope.itemsDropdownLimit = 20

  $scope.shouldShowQuickCreateBox = () ->
    can_add_project = $scope.user.hasPermission('workflow.add_project', false)
    # If we are requiring users to provide customer_id with all new projects then the quickCreate form will not work
    # as it does not offer anywhere to provide a customer_id.
    customer_id_is_required = $scope.user.hasPermission('workflow.customer_id_is_required')
    return can_add_project and !customer_id_is_required

  $scope.filterWorkflowTemplates = () ->
    $scope.workflowTemplates.filter (template) ->
      $scope.form.entityType is null or template.entity_type is null or template.entity_type == $scope.form.entityType

  $scope.limitItemsInDropdown = ->
    $scope.itemsLimit = $scope.itemsDropdownLimit

  $scope.getWorkflowStepsTooltip = (workflow) ->
    workflowStepNames = ( step.name for step in workflow.steps )
    workflowStepNames.join( '<br/>')

  $scope.doesWorkflowTemplateSupportCountry = (workflow) ->
    if !workflow
      return false
    template = get_from_list($scope.workflowTemplates, workflow)
    return template and (template.step_count > template.steps_supporting_global_count)

  $scope.doesWorkflowTemplateSupportAdverseTerms = (workflow) ->
    if !workflow
      return false
    template = get_from_list($scope.workflowTemplates, workflow)
    return template and template.steps_supporting_adverse_terms_count > 0

  $scope.groupLanguage = (item) ->
    if not item.id
      return ''
    return item?.language?.name or 'Other'

  $scope.templateUpdated = (template) ->
    if !$scope.doesWorkflowTemplateSupportAdverseTerms(template)
      $scope.form.adverseTermsId = undefined

  $scope.selectDefaultWorkflowTemplate = () ->
    defaultWorkflowId = User.defaultWorkflowId()
    if $scope.workflowTemplates and !$scope.form.template
      # The reason to look in the list of filteredWorkflowTemplates is that it is possible the user does not have
      # permission to see the workflow that has been set as the default.
      if defaultWorkflowId and _.find($scope.filterWorkflowTemplates(), {id: defaultWorkflowId})
        $scope.form.template = defaultWorkflowId
      else
        $scope.form.template = null

  $scope.selectDefaultWorkflowCountry = () ->
    # Update the form.country if the user has a defaultWorkflowCountry set in their client settings.
    # Bear in mind that not all Workflows can support a country. If one of these Workflows is set this method
    # will be overridden by `doesWorkflowTemplateSupportCountry` which is applied in the html inline.
    defaultCountryId = User.defaultWorkflowCountryId()
    if $scope.qc_countries and !$scope.form.country
      $scope.form.country = defaultCountryId

  $scope.entityTypeUpdated = () ->
    if not _.find($scope.filterWorkflowTemplates(), {id: $scope.form.template})
      $scope.form.template = undefined

  $scope.findRelatedReports = (name_variation) ->
    if name_variation and name_variation.name?.length > 0
      queryTerm = name_variation.name
      params = {
        customer_id: queryTerm,
        name: queryTerm,
        limit: 100,
        archived: false
      }
      params = $scope._addOrdering(params)
      projectPaginationSearch(params).then (response) ->
        if response.results.length
          response.count = String(response.results.length)
          if response.next
            response.count += "+"
        else
          response.count = undefined
        name_variation.relatedReports = response
    else
      delete name_variation.relatedReports

  mergePaginationResponses = (responses) ->
    response = responses[0]
    results = responses[0].results.concat(responses[1].results)
    response.results = _.chain(results)
      .filter((result) -> typeof result?.id != "undefined")
      .uniq("id")
      .value()
    response.next = response.next || responses[1].next
    return response

  findReportsAndFilter = (name_variation) ->
    $scope.findRelatedReports(name_variation)
    if $scope.subjectNameAutoFilter
      $scope.searchText = name_variation.name
      $scope.filterReportName()

  $scope.findReportsAndFilter = _.debounce(findReportsAndFilter, 300)

  $scope.advancedCreate = () ->
    # This is called from the "Advanced" link in the quick create form
    # shown at the top of the reports page (it is not shown for admins!).
    # It redirects to the main new project creation page with the details
    # pre-filled in the form based on what the user had already typed in the
    # quick create form.
    # $state.go() transitions the Angular state machine and the params are
    # received by loadStateParams in EditWorkflowController.coffee
    $state.go('project-new', {
      name: $scope.form.simple_names[0].name
      entity_type: $scope.form.entityType
      template: $scope.form.template
      country: $scope.form.country
      adverse_terms_id: $scope.form.adverseTermsId
    })

  pollAndRedirectToQuickCreatedReportsInterval = $interval () ->
  $scope.$on '$destroy', -> $interval.cancel(pollAndRedirectToQuickCreatedReportsInterval)

  $scope.createReport = (quickCreateForm) ->
    # This is only used from the quick create form at the top of the reports page.
    quickCreateForm.$submitted = true
    if quickCreateForm.$invalid
      return

    $scope.shouldRedirectToNewReport = true
    subjectName = $scope.form.simple_names?[0].name
    entityType = $scope.form.entityType
    workflowTemplate = $scope.form.template
    country = $scope.form.country
    adverseTermsId = $scope.form.adverseTermsId
    adverseWordsList = _.find($scope.adverseTermsLists, {id: adverseTermsId })?.word_list

    # create a new workflow object
    workflow = {
      countries: if country then [country] else [],
      entity_type: entityType,
      simple_names: {
        name: simple_name.name,
        adverse_terms_id: adverseTermsId,
        adverse_terms: adverseWordsList,
        is_translated: simple_name.is_translated
      } for simple_name in $scope.form.simple_names,
      template: workflowTemplate,
    }

    # Create a new project with the correct workflow
    newProject = new Api.Project
      name: subjectName,
      owner: User.id,
      process: $scope.processes?[0].id
      workflows: [workflow],

    newProject.$save().then (
      (project) ->
        $rootScope.message = "Report <strong>#{newProject.name}</strong> has been added."
        $scope.lastCreatedProjectId = project.id
        if $scope.shouldRedirectToNewReport
          pollAndRedirectToQuickCreatedReportsInterval = $scope.pollAndRedirectToQuickCreatedReports(project.id)
      ),
      (error) ->
        $scope.error_message = "There was a problem saving your project: #{error.statusText}"

  $scope.createAnotherReport = () ->
    $scope.shouldRedirectToNewReport = false
    $scope.lastCreatedProjectId = null
    cfpLoadingBar.complete()
    $interval.cancel(pollAndRedirectToQuickCreatedReportsInterval)
    resetQuickCreateForm()
    $state.go('start')

  $scope.selectDefaultWorkflowTemplate()
  $scope.selectDefaultWorkflowCountry()
